import { createRoute, Outlet, redirect } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { useAuthStore } from '@/application/stores/auth.store'

export const translationsRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'translations',
  beforeLoad: () => {
    const { user } = useAuthStore.getState()
    if (user?.role !== 'streamer' && user?.role !== 'admin') {
      throw redirect({ to: '/manage/dashboard' })
    }
  },
  component: TranslationsLayout,
})

export function TranslationsLayout() {
  return <Outlet />
}
